import { render, staticRenderFns } from "./WebshopHeader.vue?vue&type=template&id=2368ccaa&scoped=true&"
import script from "./WebshopHeader.vue?vue&type=script&lang=js&"
export * from "./WebshopHeader.vue?vue&type=script&lang=js&"
import style0 from "./WebshopHeader.vue?vue&type=style&index=0&id=2368ccaa&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2368ccaa",
  null
  
)

export default component.exports